import {Component} from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
    <section class="loader-wrapper">
      <div class="loader-content">
        <div class="loader-bg">
          <div class="loader"></div>
          <app-svg name="color-logo"></app-svg>
        </div>
        <h3>لطفا صبر نمایید ...</h3>
      </div>
    </section>`,
})

export class LoaderComponent {

}
